import React, { useState, useEffect } from "react";
import { pushToDataLayerWithValue } from "../../assets/js/event-codes-helpers";
import { useIsMount } from "../../assets/js/custom-hooks";

const SingleInterest = ({
  setInterests,
  singleInterest,
  eventCodeInterests,
}) => {
  const [active, setActive] = useState(singleInterest.isChecked);
  const isMount = useIsMount();

  const setActiveInterest = () => {
    setActive(!active);
    setInterests(singleInterest);
  };

  useEffect(() => {
    if (!isMount && eventCodeInterests.length > 0) {
      var interestSelectionSymbol = !!active ? "+" : "-";
      var key = "interest";
      var value = `${singleInterest.name}(${interestSelectionSymbol})`;

      pushToDataLayerWithValue(eventCodeInterests, key, value);
    }
  }, [active]);

  return (
    <li>
      <span
        className={`interest-label ${active ? "active" : ""}`}
        onClick={setActiveInterest}
      >
        {singleInterest.name}
      </span>
    </li>
  );
};

export default SingleInterest;
